import React from 'react';
import uuid from 'uuid/v4';

class Router {
  constructor() {
    this.store = [];
  }

  each(routes, middleware, parent) {
    routes.forEach((route) => {
      if (parent) {
        this.make({
          ...route,
          component: route.component || parent.component,
          path: parent.path + route.path,
        }, middleware);
      } else {
        this.make(route, middleware);
      }
    });
  }

  make(route, middleware) {
    const object = {
      key: uuid(),
      exact: true,
      ...route,
    };

    if (middleware) {
      const View = route.component || route.render;
      object.render = props => middleware(props, View) || <View {...props} />;
      delete object.component;
    }

    this.store.push(object);

    if (route.routes) {
      this.each(route.routes, middleware, route);
    }
  }

  apply(routes, middleware) {
    this.each(routes, middleware);
  }
}

export default new Router();
